import Application from "../../Application";
import CaseDecisionCreationPresenter, {
  ICaseDecisionCreationPresenter
} from "../presenter/CaseDecisionCreationPresenter";
import GetAllOrganisationsInteractor from "../../organisations/interactors/GetAllOrganisationsInteractor";
import GetGenericCodebookInteractor from "../../codebooks/interactor/GetGenericCodebookInteractor";
import { GenericCodebookTypes } from "../../core/common/Constants";
import GetAllCourtCaseConnectionTypesInteractor from "../../caseLawDocuments/interactor/GetAllCourtCaseConnectionTypesInteractor";

export default class ShowCaseDecisionCreationInteractor {
  private application: Application;
  private output?: ICaseDecisionCreationPresenter;
  private getAllOrganisationsInteractor: GetAllOrganisationsInteractor;
  private getGenericCodebookInteractor: GetGenericCodebookInteractor;
  private getAllCourtCaseConnectionTypesInteractor: GetAllCourtCaseConnectionTypesInteractor;

  constructor({
    application,
    getAllOrganisations,
    getGenericCodebook,
    getAllCourtCaseConnectionTypes
  }) {
    this.application = application;
    this.getAllOrganisationsInteractor = getAllOrganisations;
    this.getGenericCodebookInteractor = getGenericCodebook;
    this.getAllCourtCaseConnectionTypesInteractor =
      getAllCourtCaseConnectionTypes;
  }
  private async getAllOrganisations() {
    return this.getAllOrganisationsInteractor.execute();
  }
  private async getReferenceLists() {
    return Promise.all([
      this.getAllOrganisations(),
      this.getAllCourtCaseConnectionTypes(),
      this.getDecisionTypes(),
      this.getCourtCaseTypes()
    ]);
  }
  private async getAllCourtCaseConnectionTypes() {
    return this.getAllCourtCaseConnectionTypesInteractor.execute();
  }
  private async getDecisionTypes() {
    return this.getGenericCodebookInteractor.execute(
      GenericCodebookTypes.DECISION_TYPE,
      false
    );
  }
  private async getCourtCaseTypes() {
    return this.getGenericCodebookInteractor.execute(
      GenericCodebookTypes.COURT_CASE_TYPE,
      false
    );
  }
  execute(caseNumber?: string) {
    this.output = CaseDecisionCreationPresenter({
      application: this.application,
      initialState: {
        organisations: [],
        selectedOrganisationId: NaN,
        caseDecisionTypes: [],
        organisationIndexes: [],
        caseDecisionTypeOrganisationIndex: [],
        courtCaseTypes: [],
        createCourtCasePopupVisible: false,
        createCourtCaseModalVisible: false,
        decisionTypes: [],
        courtCaseConnectionTypeList: [],
        publishedCaseDecisions: [],
        invalidatePublishedCaseDecisionsVisible: false
      }
    });

    this.getReferenceLists()
      .then(
        ([
          organisations,
          courtCaseConnectionTypeList,
          decisionTypes,
          courtCaseTypes
        ]) => {
          this.output?.loadReferenceValues(
            organisations,
            courtCaseConnectionTypeList,
            decisionTypes,
            courtCaseTypes
          );
        }
      )
      .then(() => caseNumber && this.output?.findCourtCaseDetails(caseNumber));
    return this.output;
  }
}
